export default __webpack_public_path__ + "static/media/facebook.c4c69ef8.svg";